
import SquareButton from '../components/elements/SquareButton.js';
import { useEffect, useRef, useState } from 'react';

import { fetchFamilies, fetchHouseByHouse, fetchHouseByPopulation, fetchHouseBySchool } from '../fetch/search.js';

import { fetchPopulation } from '../fetch/search.js';
import { fetchStreets } from '../fetch/search.js';
import { fetchSchools } from '../fetch/search.js';
import { selectLangObj } from '../reducers/langReducer.js';
import { useDispatch, useSelector } from 'react-redux';
import SearchLayout from '../components/search/SearchLayout.js';

import BooksSlider from "../components/slider_variants/BooksSlider.js"
import DocumentsSlider from "../components/slider_variants/DocumentsSlider.js"
import ImagesSlider from "../components/slider_variants/ImagesSlider.js"
import MediaSlider from "../components/slider_variants/MediaSlider.js"
import SvedocenjaSlider from "../components/slider_variants/SvedocenjaSlider.js"
import MainLinks from "../components/slider_variants/MainLinks.js"
import RecentDocuments from "../components/slider_variants/RecentDocuments.js"
import RecentPosters from "../components/slider_variants/RecentPosters.js"
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid'
import SquareButtonSm from '../components/elements/SquareButtonSm.js';
import { useParams } from 'react-router';
import { useNavigate } from "react-router";
import { SearchState } from "../utility/searchStates.js";
import Groups from '../components/slider_variants/Groups.js';

function Home() {

  const [searchOn, setSearchOn] = useState(false);
  const [dropOn, setDropOn] = useState(false);
  const [searchState, setSearchState] = useState("family");
  const [term, setTerm] = useState("");
  const [error, setError] = useState(false);
  const langObj = useSelector(selectLangObj);
  const dispatch = useDispatch();
  const ref = useRef(null); // ref => { current: null }
  const navigate = useNavigate();

  const params = useParams();
  function getSubState() {

    switch (searchState) {
      case SearchState.PEOPLE:
        return 'population';
      case SearchState.FAMILY:
      case SearchState.STREETS:
        return 'house';
      case SearchState.SCHOOL:
        return 'school';
      default:
        return '';
    }
  }

  function bgSearchBase() {

    // if(searchState && state && state != searchState){
    //   return " bg-white text-black  ";
    // }

    return " flex-shrink basis-1/2 md:basis-1/4 lg:basis-1/4 xl:basis-1/4 md:hover:basis-1/3 ";
  }

  function bgSearch(state) {

    // if(searchState && state && state != searchState){
    //   return " bg-white text-black  ";
    // }

    return (state == searchState ? "  font-semi-bold backdrop-blur-xl bg-slate-700 bg-opacity-90 text-white " : "  text-slate-300 backdrop-blur-xl bg-slate-700 bg-opacity-30 font-semi-bold ");
  }
  function bgSearchSm(state) {

    // if(searchState && state && state != searchState){
    //   return " bg-white text-black  ";
    // }

    return (state == searchState ? " font-semi-bold  bg-slate-700 " : " bg-slate-500 hover:bg-slate-600  " + "   font-semi-bold ");
  }


  function IconSearch() {
    if (!searchOn) {
      return;
    }

    let text = "";
    switch (params.type) {
      case SearchState.FAMILY:
        text = langObj["App"]["Families"];
        break;
      case SearchState.PEOPLE:
        text = langObj["App"]["People"];
        break;
      case SearchState.STREETS:
        text = langObj["App"]["Streets"];
        break;
      case SearchState.SCHOOL:
        text = langObj["App"]["School"];
        break;
      default:
        text = "";
    }

    return (
      <div onClick={() => { setDropOn(!dropOn); }} className={_bgSearch(params.type) + " cursor-pointer rounded-s  flex flex-row justify-center items-center relative  p-2 text-white"}>
        {text}
        {dropOn ? (<ChevronUpIcon className='size-4'></ChevronUpIcon>) : (<ChevronDownIcon className='size-4'></ChevronDownIcon>)}
        {

          searchOn &&
          <div className={(dropOn ? 'h-44' : 'h-0') + ' flex flex-col absolute  top-full left-0  overflow-hidden transition-all duration-300'} >

            <SquareButtonSm
              onClick={() => { setSearch(SearchState.FAMILY); }}
              name={langObj["App"]["Families"]}
              classAdd={bgSearchSm(SearchState.FAMILY)}
            />
            <SquareButtonSm
              onClick={() => { setSearch(SearchState.PEOPLE); }}
              name={langObj["App"]["People"]}
              classAdd={bgSearchSm(SearchState.PEOPLE)}
            />
            <SquareButtonSm
              onClick={() => { setSearch(SearchState.STREETS); }}
              name={langObj["App"]["Streets"]}
              classAdd={bgSearchSm(SearchState.STREETS)}
            />
            <SquareButtonSm
              onClick={() => { setSearch(SearchState.SCHOOL); }}
              name={langObj["App"]["School"]}
              classAdd={bgSearchSm(SearchState.SCHOOL)}
            />

          </div>
        }
      </div>
    )


  }
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      SearchPress();
      // Add your desired action here, e.g., submit the form or update state
    }
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setError(false);
    setTerm(value)
  };

  function SearchPress() {

    setError(!term);

    if (!error) {
      navigate("/search/" + searchState + "/" + term);
    }

  }
  function Search() {
    setSearchOn(true);

    if (params.person) {
      dispatch(fetchHouseByHouse({ param: params.person, page: 0 }));

      // switch (getSubState(searchState)) {
      //   case "house":
      //     dispatch(fetchHouseByHouse({ param: params.person, page: 1 }));
      //   case "population":
      //     dispatch(fetchHouseByPopulation({ param: params.person, page: 1 }));
      //   case "school":
      //     dispatch(fetchHouseBySchool({ param: params.person, page: 1 }));

      // }
    } else {



      switch (params.type) {
        case SearchState.FAMILY:
          dispatch(fetchFamilies({ param: params.term || "", rbr: params.person || -1, page: 0 }));
          break;
        case SearchState.PEOPLE:
          dispatch(fetchPopulation({ param: params.term || "", rbr: params.person || -1, page: 0 }));
          break;
        case SearchState.STREETS:
          dispatch(fetchStreets({ param: params.term || "", rbr: params.person || -1, page: 0 }));
          break;
        case SearchState.SCHOOL:
          dispatch(fetchSchools({ param: params.term || "", rbr: params.person || -1, page: 0 }));
          break;
        default:
          return;



      }

    }
  }
  useEffect(() => {
    if (!params.search) {
      setSearchOn(false)
    }


  }, [params.search])


  useEffect(() => {
    if (params.person) {
      Search();
    }


  }, [params.person])


  useEffect(() => {
    if (params.term) {
      Search();
    }
    setError(false);


  }, [params.term, params.type])

  useEffect(() => {

    if (searchOn && term) {
      SearchPress();
    }


  }, [searchState])
  useEffect(() => {

    if (params.type && params.type != searchState) {
      setSearch(params.type);
    }


  }, [params.type]);
  useEffect(() => {

    if (params.term && params.term != term) {
      setTerm(params.term);
    }


  }, []);
  function setSearch(state) {

    setSearchState(state);


  }

  function _placeholder() {

    switch (searchState) {
      case SearchState.FAMILY:
        return langObj["PlaceHolderFamily"];
      case SearchState.PEOPLE:
        return langObj["PlaceHolderPeople"];
      case SearchState.STREETS:
        return langObj["PlaceHolderStreets"];
      case SearchState.SCHOOL:
        return langObj["PlaceHolderSchools"];
      default:
        return '';
    }
  }

  function _bgSearch(state) {

    let stateSw = state || searchState;
    switch (stateSw) {
      case SearchState.FAMILY:
        return 'bg-teal-800';
      case SearchState.PEOPLE:
        return 'bg-yellow-500';
      case SearchState.STREETS:
        return 'bg-orange-400';
      case SearchState.SCHOOL:
        return 'bg-red-600';
      default:
        return '';
    }
  }
  // function _textSearch(state) {

  //   let stateSw = state || searchState;
  //   switch (stateSw) {
  //     case "family":
  //       return "text-teal-800"
  //     case "people":
  //       return "text-yellow-500"
  //     case "streets":
  //       return "text-orange-400"
  //     case "school":
  //       return "text-red-600"
  //     default:
  //       return "";
  //   }
  // }
  return (
    <div className='w-full' ref={ref}>

      <div className={"  justify-center transition-all flex gap-3 flex-col mb-3 h-full  w-full  items-center"} style={{ height: searchOn ? ref.current?.parentElement.offsetHeight : "80vh" }}>

        <div className={' sm:justify-center w-full md:w-8/12  items-stretch md:p-6  pb-3 sm:p-3 flex flex-col gap-3 h-full'}>

          <div className={" transition-all flex flex-row z-10 isolate"}>

            <div className={" transition-all flex flex-col md:flex-row gap-6  w-full "}>

              <div className={(searchOn ? "rounded-xl" : " sm:rounded-tl-3xl sm:rounded-br-3xl ") + "  backdrop-blur-lg flex flex-col items-stretch  p-4 sm:p-6 gap-3 md:gap-6 border max-sm:border-t-0 max-sm:border-x-0 border-gray-600  flex-grow basis-full"}>


                <div className={(searchOn ? "opacity-0 hidden" : " opacity-100  ") + "  transition-all flex flex-col justify-around   items-stretch text-wrap  gap-3 p-4 sm:p-6  bg-amber-300 backdrop-blur-xl  bg-opacity-50 border border-orange-950 "}>
                  <p class="text-justify text-sm sm:text-md md:text-lg md:p-3">
                    {langObj["App"]["Intro1"]}
                  </p>
                  <p class="text-start text-sm sm:text-md md:text-lg  font-semibold rounded-sm md:p-3">
                    {langObj["App"]["Intro2"]}
                  </p>
                </div>
                <div className={"  transition-all flex flex-col justify-around   items-stretch text-wrap  gap-3 "}>

                  {!searchOn &&
                    <div className='flex justify-around flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap items-stretch'>

                      <SquareButton
                        onClick={() => { setSearch(SearchState.FAMILY); }}
                        name={langObj["App"]["Families"]}
                        classAdd={bgSearch(SearchState.FAMILY) + " "}
                        Accent={_bgSearch(SearchState.FAMILY)}
                        BaseClass={bgSearchBase()}

                        ElemClass={bgSearchBase()+"pe-1 sm:pe-2 sm:pb-2 md:pe-2 md:pb-0   "}
                      />
                      <SquareButton
                        onClick={() => { setSearch(SearchState.PEOPLE); }}
                        name={langObj["App"]["People"]}
                        classAdd={bgSearch(SearchState.PEOPLE) + "  "}
                        Accent={_bgSearch(SearchState.PEOPLE)}
                        BaseClass={bgSearchBase()}
                        ElemClass={bgSearchBase()+" pe-0 pb-1 sm:pb-2 md:pe-2 md:pb-0 "}

                      />
                      <SquareButton
                        onClick={() => { setSearch(SearchState.STREETS); }}
                        name={langObj["App"]["Streets"]}
                        classAdd={bgSearch(SearchState.STREETS) + " "}
                        Accent={_bgSearch(SearchState.STREETS)}
                        ElemClass={bgSearchBase()+" pe-1 sm:pe-2 pb-0 md:pe-2 md:pb-0   "}

                      />
                      <SquareButton
                        onClick={() => { setSearch(SearchState.SCHOOL); }}
                        name={langObj["App"]["School"]}
                        classAdd={bgSearch(SearchState.SCHOOL)}
                        Accent={_bgSearch(SearchState.SCHOOL)}
                        ElemClass={bgSearchBase()+" pe-0 pb-0  "}

                      />


                    </div>
                  }

                  <div className={" flex flex-col md:flex-row gap-3 md:gap-0  justify-between items-stretch"}>
                    {IconSearch()}
                    <input onKeyUp={handleKeyPress} placeholder={_placeholder()} value={term} onChange={handleInputChange} class={(error ? "placeholder-red-600 border border-red-600 " : "") + (searchOn ? "rounded-e" : "rounded") + " transition-all duration-500 me-3 flex-grow basis-full shadow appearance-none border  w-full max-sm:text-sm py-1 sm:py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"} id="username" type="text" />
                    <button onClick={() => SearchPress()} class={(searchOn ? "" : "") + " bg-lime-800 hover:bg-lime-900 text-white max-sm:text-sm p-1 sm:p-2 focus:outline-none focus:shadow-outline"} type="button">
                      {langObj["Search"]}
                    </button>

                    {
                      searchOn &&
                      (<button onClick={() => { navigate("/"); }} class=" rounded-e  bg-slate-700  hover:bg-slate-900  text-white  max-sm:text-sm py-1 sm:py-2 px-3  focus:outline-none focus:shadow-outline" type="button">
                        {langObj["Back"]}
                      </button>)
                    }


                  </div>
                </div>
              </div>

            </div>
          </div>
          {
            searchOn && (
              <SearchLayout Type={searchState} SubType={getSubState()} term={term} rbr={params.person}></SearchLayout>
            )
          }
        </div>
      </div>


      <div className='flex flex-col gap-6 md:p-6 p-3 border-t border-gray-600 bg-slate-500 bg-opacity-50 backdrop-blur-lg'>
        <RecentDocuments></RecentDocuments>
        <RecentPosters />
        <DocumentsSlider></DocumentsSlider>
        <Groups></Groups>
        <MediaSlider></MediaSlider>
        <SvedocenjaSlider></SvedocenjaSlider>
        <BooksSlider></BooksSlider>
        <ImagesSlider></ImagesSlider>
        <MainLinks />
      </div>


    </div>






  )


}

export default Home;